import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { useState, useEffect, useCallback } from 'react';

var useDrag = function useDrag(_ref) {
  var position = _ref.position,
      minPosition = _ref.minPosition,
      maxPosition = _ref.maxPosition,
      onChange = _ref.onChange,
      onChangeEnd = _ref.onChangeEnd,
      isDisabled = _ref.isDisabled,
      defaultPosition = _ref.defaultPosition;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDragging = _useState2[0],
      setIsDragging = _useState2[1];

  var _useState3 = useState(position || defaultPosition),
      _useState4 = _slicedToArray(_useState3, 2),
      currentPosition = _useState4[0],
      setCurrentPosition = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      initialOffset = _useState6[0],
      setInitialOffset = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      initialClientPosition = _useState8[0],
      setInitialClientPosition = _useState8[1];

  useEffect(function () {
    setCurrentPosition(position || defaultPosition);
  }, [position, defaultPosition, setCurrentPosition]);
  var handleMouseMove = useCallback(function (event) {
    if (isDragging) {
      var _position;

      if (event.touches) {
        var touch = event.touches[0];

        if (touch) {
          _position = touch.clientX;
        }
      } else {
        _position = event.clientX;
      }

      var _currentPosition = initialOffset + _position - initialClientPosition;

      if (_currentPosition >= minPosition && _currentPosition <= maxPosition) {
        onChange === null || onChange === void 0 ? void 0 : onChange(_currentPosition);
        setCurrentPosition(_currentPosition);
      }
    }
  }, [isDragging, onChange, initialOffset, maxPosition, minPosition, initialClientPosition]);
  var handleDragEnd = useCallback(function () {
    if (isDragging) {
      setIsDragging(false);
      onChangeEnd === null || onChangeEnd === void 0 ? void 0 : onChangeEnd(currentPosition);
    }
  }, [isDragging, currentPosition, onChangeEnd]);

  var handleMouseDown = function handleMouseDown(event) {
    if (isDisabled) return;
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(true);
    setInitialClientPosition(event.clientX);
    setInitialOffset(currentPosition);
  };

  var handleTouchStart = function handleTouchStart(event) {
    if (isDisabled) return;
    setIsDragging(true);

    if (event.touches) {
      var touch = event.touches[0];

      if (touch) {
        setInitialClientPosition(touch.clientX);
      }
    }

    setInitialOffset(currentPosition);
  };

  useEffect(function () {
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('touchmove', handleMouseMove);
    window.addEventListener('mouseup', handleDragEnd);
    window.addEventListener('touchend', handleDragEnd);
    return function () {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('touchmove', handleMouseMove);
      window.removeEventListener('mouseup', handleDragEnd);
      window.removeEventListener('touchend', handleDragEnd);
    };
  }, [handleMouseMove, handleDragEnd]);
  return {
    currentPosition: currentPosition,
    isDragging: isDragging,
    handleMouseDown: handleMouseDown,
    handleTouchStart: handleTouchStart
  };
};

export { useDrag };